/**
 * Compute SHA-256 hex digest of a File using Web Crypto API.
 * Available in all modern browsers since ~2014. ~10–15ms per 1 MB on
 * desktop, so 200 × 1 MB ≈ 3 seconds in the worst case.
 */
export async function sha256OfFile(file: File): Promise<string> {
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);

    const bytes = new Uint8Array(hashBuffer);
    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
        hex += bytes[i].toString(16).padStart(2, '0');
    }
    return hex;
}
